// Import model
import { PatternTypeOptionCondition } from '../models/PatternTypeOptionCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { PatternTypeOptionIndexedFields } from '../models/PatternTypeOptionIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { PatternTypeOptionIndexedFieldsSerializer } from './PatternTypeOptionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PatternTypeOptionCondition - handles JSON serialization and deserialization with type validation
 */
export class PatternTypeOptionConditionSerializer {
  /**
   * Deserializes a JSON string into a PatternTypeOptionCondition instance
   */
  static deserialize(json: string): PatternTypeOptionCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PatternTypeOptionCondition instance
   */
  static fromObject(obj: any): PatternTypeOptionCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PatternTypeOptionCondition');
    }


    const instance: PatternTypeOptionCondition = {
      fieldName: obj['fieldName'] as PatternTypeOptionIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PatternTypeOptionCondition instances
   */
  static deserializeArray(json: string): PatternTypeOptionCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PatternTypeOptionCondition instance to a JSON string
   */
  static serialize(instance: PatternTypeOptionCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PatternTypeOptionCondition instance to a plain object
   */
  static toObject(instance: PatternTypeOptionCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of PatternTypeOptionCondition instances to a JSON string
   */
  static serializeArray(instances: PatternTypeOptionCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
